import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Alert from "react-bootstrap/Alert";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import AdminUserCreateForm from "./admin-user-create-form";
import CancelModal from "../../../../components/cancel-modal/cancel-modal";
import ConfirmationModal from "../../../../components/confirmation-modal/confirmation-modal";
import {
  CreateUserNew,
  EditUserNew,
  GetEditUserNew,
  UserExistsWithName,
  ValidateUserEmail,
} from "../../../../services/api/user-api";
import { GetAllRolesForDepartment } from "../../../../services/api/role-api";
import { GetAllDepartmentsAPI, GetAllDepartmentsForCreateScreen, AllSubDepartmentsFromDepartment } from "../../../../services/api/department-api";
import { LoginContext } from "../../../../services/api/authentication-api";
import { ToBase64 } from "../../../../services/api/file-api";
import { OLD_UI_URL } from "../../../../services/api/api-client";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUser } from "../../../../redux/user/user-selector";
import "./admin-user-create-panel.scss";

const AdminUserCreatePanelNew = ({ location, history, currentUser }) => {
  const [user, setUser] = useState({
    Id: 0,
    UserName: "",
    Name: "",
    Email: "",
    CompanyId: 0,
    RoleId: 0,
    Department: "",
    Password: "",
    Active: true,
    ProfileImage: "",
    profileImageRaw: "",
    isPhotoSet: false,
    passwordType: "password",
    confPasswordType: "password",
    selectedDepartment: {},
    selectedRole: {},
    allDepartments: [],
    allRoles: [],
    subDepartments: [],
    isLoadingSubDepartments: false,
    isEdit: location.pathname.split("/")[3] === "edit",
  });
  const [alert, setAlert] = useState({
    show: false,
    action: "",
    message: "",
    variant: "danger",
  });
  const [showCancelPanel, setShowCancelPanel] = useState(false);
  const [showConfirmPanel, setShowConfirmPanel] = useState(false);
  const [disableSubDepartment, setDisableSubDepartment] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const context = useContext(LoginContext);
  const companyId = currentUser?.department?.CompanyID ?? currentUser?.department?.companyID ?? 0;

  useEffect(() => {
    const fetchInitialData = async () => {
      let userID = location.pathname.split("/")[4];
  
      let searchQuery = {
        userId: context.userID,
        pageSize: 100000,
        pageNumber: 1,
        sortDesc: false,
        sortBy: "name",
        filters: [],
      };
  
      const allDepartments = await GetAllDepartmentsForCreateScreen(searchQuery);
      
      if (!user.isEdit) {
        try {
          let allRoles = [];
          let allSubDepartments = [];
  
          if (!currentUser.profile.isSuperAdminRole) {
            allRoles = await GetAllRolesForDepartment(companyId);
            allSubDepartments = await AllSubDepartmentsFromDepartment(companyId);
          }
  
          setUser({
            ...user,
            allDepartments: allDepartments.data.dataList,
            CompanyId: currentUser.profile.isSuperAdminRole
              ? user.CompanyId
              : companyId,
            selectedDepartment: currentUser.profile.isSuperAdminRole
              ? user.selectedDepartment
              : {
                  id: companyId,
                  name: currentUser.department.Name,
                },
            allRoles: allRoles?.data,
            subDepartments: allSubDepartments?.data?.map(subDept => ({
              id: subDept.Id.toString(),
              name: subDept.Name,
              disabled: !subDept.Active,
            })),
          });
  
          setLoaded(true);
        } catch (error) {
          setAlert({
            show: true,
            action: "Cannot get blank user.",
            message: error.toString(),
            variant: "danger",
          });
        }
      } else {
        try {
          const result = await GetEditUserNew(userID);
          const allRoles = await GetAllRolesForDepartment(result.CompanyId);
          let allSubDepartments = [];
          let selectedSubDepartments = [];
          try {
            const subDeptResponse = await AllSubDepartmentsFromDepartment(result.CompanyId);
            if (subDeptResponse.status === 200) {
              const selectedSubDepartmentIds = result?.subDepartment?.map(subDept => subDept.Id.toString()) || [];
              allSubDepartments = subDeptResponse.data
                .filter(subDept => subDept.Active || selectedSubDepartmentIds.includes(subDept.Id.toString()))
                .map(subDept => ({
                  id: subDept.Id.toString(),
                  name: subDept.Active ? subDept.Name : `${subDept.Name} [Inactive]`,
                  disabled: !subDept.Active,
                }));
              selectedSubDepartments = processSelectedSubDepartments(result);
            } else {
              selectedSubDepartments = processSelectedSubDepartments(result);
              setDisableSubDepartment(true);
            }
          } catch (subDeptError) {
            console.error("Error fetching sub-departments:", subDeptError);
            selectedSubDepartments = [];
          }
  
          setUser({
            ...user,
            Id: result.Id,
            UserName: result.UserName,
            Name: result.Name,
            Email: result.Email,
            CompanyId: result.CompanyId,
            RoleId: result.RoleId,
            Active: result.Active,
            Department: result.Department,
            Password: result.Password,
            passwordConfirmation: result.Password,            
            ProfileImage: result.ProfileImage,
            allDepartments: allDepartments.data.dataList,
            allRoles: allRoles?.data,
            selectedDepartment: {
              id: result.CompanyId,
              name: result.CompanyName,
            },
            selectedRole: {
              id: result.RoleId,
              name: result.StrRole,
            },
            subDepartments: allSubDepartments, 
            selectedSubDepartments: selectedSubDepartments,
            isPhotoSet: result.ProfileImage && result.ProfileImage !== "",
          });
  
          setLoaded(true);
        } catch (error) {
          setAlert({
            show: true,
            action: "Cannot get wanted user.",
            message: error.toString(),
            variant: "danger",
          });
        }
      }
    };
  
    fetchInitialData();
  }, []);

  const processSelectedSubDepartments = (result) => {
    return result?.subDepartment?.map(subDept => ({
      id: subDept.Id,
      name: subDept.Active ? subDept.Name : `${subDept.Name} [Inactive]`,
      disabled: !subDept.Active,
    })) || [];
  };

  const onDepartmentSelected = async (department, setFieldValue) => {

    if (user.selectedDepartment && user.selectedDepartment.id === department.id) {
      return;
    }

    try {
      setUser(prevState => ({
        ...prevState,
        selectedDepartment: department,
        selectedRole: null,
        allRoles: [],
        subDepartments: [],
        isLoadingSubDepartments: true,
      }));
  
      setFieldValue('subDepartment', []);
  
      const [rolesResponse, subDepartmentsResponse] = await Promise.all([
        GetAllRolesForDepartment(department.id),
        AllSubDepartmentsFromDepartment(department.id),
      ]);
      if(subDepartmentsResponse.status !== 200) {
        setDisableSubDepartment(true);
      }
      const allRoles = rolesResponse?.data || [];
      const fetchedSubDepartments = subDepartmentsResponse?.data || [];
  
      const selectedSubDepartmentIds = (user.selectedSubDepartments || []).map(subDept => subDept.id);
  
      const subDepartments = fetchedSubDepartments
        .filter(subDept => subDept.Active || selectedSubDepartmentIds.includes(subDept.Id.toString())) 
        .map(subDept => ({
          id: subDept.Id.toString(),
          name: subDept.Active ? subDept.Name : `${subDept.Name} [Inactive]`,
          disabled: !subDept.Active, 
        }));
  
      setUser(prevState => ({
        ...prevState,
        allRoles: allRoles,
        subDepartments: subDepartments,
        isLoadingSubDepartments: false,
      }));
    } catch (error) {
        console.error("Error fetching roles or sub-departments:", error);
        setUser(prevState => ({
            ...prevState,
            isLoadingSubDepartments: false,
        }));
    }
};


  const getBase64FromImageUrl = (URL) => {
    let img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.src = URL;
    img.onload = function () {
      let canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;

      let ctx = canvas.getContext("2d");
      ctx.drawImage(this, 0, 0);
    };
  };

  const saveUser = (u, actions) => {
    let newUser = {
      ...u,
      ProfileImage: user?.ProfileImage,
      profileImageRaw: user?.profileImageRaw,
    };
    UserExistsWithName(newUser.UserName).then((result) => {
      if (result != null) {
        if (result.Id !== newUser.Id) {
          setAlert({
            show: true,
            action: "A user with that login exists.",
            message: "",
            variant: "danger",
          });
          actions.setSubmitting(false);
          return;
        } else {
          updateUser(newUser);
        }
      } else {
        updateUser(newUser);
      }
      actions.setSubmitting(false);
    });
  };

  const updateUser = async (u) => {
    let lowerEmail = u.Email.toLowerCase();
    let newUser = { ...u, Email: lowerEmail };

    try {
      const result = await ValidateUserEmail(lowerEmail, newUser.Id, context);
      if (result.status === 200) {
        if (!user.isEdit) {
          newUser = { ...newUser, Active: true };
          try {
            await CreateUserNew(newUser);
            setShowConfirmPanel(true);
          } catch (error) {
            setAlert({
              show: true,
              action: "Cannot create new user.",
              message: error?.toString(),
              variant: "danger",
            });
          }
        } else {
          if (u.ProfileImage.includes("https://")) {
            u.ProfileImage = getBase64FromImageUrl(u.ProfileImage);
          }
          if (!user.isPhotoSet) u.ProfileImage = "";
          try {
            await EditUserNew(u);
            setShowConfirmPanel(true);
          } catch (error) {
            setAlert({
              show: true,
              action: "Could not update current user.",
              message: result.data.toString(),
              variant: "danger",
            });
          }
        }
      } else {
        setAlert({
          show: true,
          action: user.isEdit ? "Cannot update user" : "Cannot create user",
          message: result?.response?.data?.toString(),
          variant: "danger",
        });
      }
    } catch (error) {
      setAlert({
        show: true,
        action: user.isEdit ? "Cannot update user" : "Cannot create user",
        message: error.toString(),
        variant: "danger",
      });
    }
  };

  const onProfilePictureUploaded = async (e) => {
    let file = e.target.files[0];
    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/bmp",
      "image/tiff",
      "image/gif",
    ];

    if (!validImageTypes.includes(file.type)) {
      setAlert({
        show: true,
        action: "Invalid picture format.",
        message: "Image must be either jpg, png, bmp, tiff, or gif.",
        variant: "danger",
      });
    } else {
      if (file.size > 2000000) {
        setAlert({
          show: true,
          action: "File size too large.",
          message: "Image must be less than 2MB.",
          variant: "danger",
        });
        return;
      }

      if (file.type === "image/tiff") {
        // Browsers cannot render TIFF data URLs, so the preview and the saved
        // avatar would both show as a gray placeholder. Convert to a PNG data
        // URL client-side — same shared util as the department logo upload
        // (TAD-5781).
        try {
          const { tiffToPngDataUrls } = await import(
            "../../../../util/tiff-helpers"
          );
          const buffer = await file.arrayBuffer();
          const [dataUrl] = tiffToPngDataUrls(buffer, 1);
          // Re-check the cap: PNG re-encoding can inflate the payload.
          if (dataUrl.slice(dataUrl.indexOf(",") + 1).length * 0.75 > 2000000) {
            setAlert({
              show: true,
              action: "File size too large.",
              message: "Image must be less than 2MB.",
              variant: "danger",
            });
            return;
          }
          setUser({
            ...user,
            profileImageRaw: dataUrl,
            ProfileImage: dataUrl.split(",")[1],
            isPhotoSet: true,
          });
        } catch (error) {
          setAlert({
            show: true,
            action: "Invalid picture format.",
            message:
              "The TIFF image could not be processed. Please try a different image.",
            variant: "danger",
          });
        }
        return;
      }

      ToBase64(file).then((result) => {
        setUser({
          ...user,
          profileImageRaw: result,
          ProfileImage: result.split(",")[1],
          isPhotoSet: true,
        });
      });
    }
  };

  const showHidePassword = (event, passType) => {
    event.preventDefault();
    if (passType === "password") {
      setUser({
        ...user,
        passwordType: user.passwordType === "password" ? "text" : "password",
      });
    } else {
      setUser({
        ...user,
        confPasswordType:
          user.confPasswordType === "password" ? "text" : "password",
      });
    }
  };

  const clearImage = (event) => {
    event.preventDefault();
    setUser({
      ...user,
      ProfileImage:
        OLD_UI_URL + "ApplicationDocuments/Files/202006250330536082.png",
      profileImageRaw:
        OLD_UI_URL + "ApplicationDocuments/Files/202006250330536082.png",
      isPhotoSet: false,
    });
  };

  const displayAlert = () => {
    window.setTimeout(() => {
      setAlert({ ...alert, show: false });
    }, 5000);

    return (
      <Alert
        show={alert.show}
        onClose={() => setAlert({ ...alert, show: false })}
        variant={alert.variant}
        dismissible
      >
        <Alert.Heading>{alert.action}</Alert.Heading>
        <p>{alert.message}</p>
      </Alert>
    );
  };

  return (
    <div className="user-edit-panel">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {user.isEdit ? "TRIYO · " + user.Name : "TRIYO · Create User"}
        </title>
      </Helmet>
      {alert.show ? displayAlert() : <></>}
      {showCancelPanel ? (
        <CancelModal
          show={showCancelPanel}
          onHide={() => {
            setShowCancelPanel(false);
          }}
          redirectURL={"/admin?tab=users"}
        />
      ) : (
        <> </>
      )}
      {showConfirmPanel && (
        <ConfirmationModal
          show={showConfirmPanel}
          onHide={() => {
            history.push("/admin?tab=users");
          }}
          redirectURL={"/admin?tab=users"}
          header={!user.isEdit && "Create User Confirmation"}
          confirmationText={
            !user.isEdit && "User has been created successfully."
          }
        />
      )}
      <h4 className="panel-title">
        {user.isEdit ? "Edit User" : "Create User"}{" "}
      </h4>
      <AdminUserCreateForm
        context={context}
        currentUser={currentUser}
        loaded={loaded}
        user={user}
        saveUser={(values, actions) => saveUser(values, actions)}
        onDepartmentSelected={(value, setFieldValue) => {
          onDepartmentSelected(value, setFieldValue);
        }}
        setUser={(user) => {
          setUser(user);
        }}
        onProfilePictureUploaded={(e) => onProfilePictureUploaded(e)}
        clearImage={(e) => clearImage(e)}
        showHidePassword={(e, passType) => showHidePassword(e, passType)}
        onCancel={() => setShowCancelPanel(true)}
        disableSubDepartment={disableSubDepartment}
      />
    </div>
  );
};

const mapState = createStructuredSelector({
  currentUser: selectUser,
});

AdminUserCreatePanelNew.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
};

AdminUserCreatePanelNew.contextType = LoginContext;
export default connect(mapState, null)(withRouter(AdminUserCreatePanelNew));
